import { Component, Element, h, Prop, State } from '@stencil/core';
import { Breakpoint, Breakpoints, MobileUtility } from '~service/mobile-utility';

@Component({
  tag: 'mama-iframe',
})
export class MamaIframe {
  @Prop() src: string;
  @Prop() heightSm: string;
  @Prop() heightMd: string;
  @Prop() heightLg: string;
  @Prop() heightXl: string;
  @Prop({ attribute: 'title' }) _title: string;

  @State() height: string;

  @Element() el: HTMLElement;

  viewportChangedListener = (breakpoint: Breakpoint) => this.onBreakpointChange(breakpoint);

  componentWillLoad() {
    MobileUtility.addViewportChangedListener(this.viewportChangedListener);
  }

  onBreakpointChange(breakpoint: Breakpoint) {
    switch (breakpoint) {
      case Breakpoints.MOBILE:
        this.height = this.heightSm;
        break;
      case Breakpoints.TABLET:
        this.height = this.heightMd;
        break;
      case Breakpoints.DESKTOP:
        this.height = this.heightLg;
        break;
      case Breakpoints.LARGE_DESKTOP:
        this.height = this.heightXl;
        break;
    }
  }

  disconnectedCallback() {
    MobileUtility.removeViewportChangedListener(this.viewportChangedListener);
  }

  render() {
    return <iframe src={this.src} height={this.height} scrolling="no" frameborder="0" loading="lazy" title={this._title} />;
  }
}
